'use client'

import { ComponentSpinner } from '@tebuto/layout/Spinner'
import Heading from '@tebuto/typography/Heading'

export default function StripeCheckoutReturnConfirming() {
    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
            <ComponentSpinner className="size-10 mb-6" />
            <Heading level={1} className="text-primary-700 mb-4">
                Zahlung wird bestätigt…
            </Heading>
            <p className="text-lg text-muted-foreground">Bitte warten Sie einen Moment.</p>
        </div>
    )
}
